const messages = {
  error_unavailable: 'Sito non raggiungibile',
  error_not_found: 'Pagina non trovata'
}

export default {
  messages
}
